module.exports = __webpack_public_path__ + "static/img/jx_tk.28be0ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx_tk.png
// module id = cIzt
// module chunks = 0